(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-title"] && !Shopify.designMode) return;
  try {
    

  function kk_share_buttons() {
  	var currentUrl = '{{ current_url }}'
  	var pageTitle = '{{ page_title }}'
  	var imageSrc = '{{ image_src }}'

  	var twitterURL =
  		'https://twitter.com/intent/tweet?text=' +
  		encodeURIComponent(pageTitle) +
  		'&url=' +
  		encodeURIComponent(currentUrl)
  	var facebookURL =
  		'https://www.facebook.com/sharer/sharer.php?u=' +
  		encodeURIComponent(currentUrl)
  	var linkedInURL =
  		'https://www.linkedin.com/sharing/share-offsite/?url=' +
  		encodeURIComponent(currentUrl)
  	var pinterestURL =
  		'https://pinterest.com/pin/create/button/?url=' +
  		encodeURIComponent(currentUrl) +
  		'&media=' +
  		encodeURIComponent(imageSrc) +
  		'&description=' +
  		encodeURIComponent(pageTitle)
  	var whatsappURL =
  		'https://api.whatsapp.com/send?text=' +
  		encodeURIComponent(pageTitle + ' ' + currentUrl)
  	var redditURL =
  		'https://www.reddit.com/submit?url=' +
  		encodeURIComponent(currentUrl) +
  		'&title=' +
  		encodeURIComponent(pageTitle)

  	var content_social =
  		'<div class="kk-social d-flex gap-3">' +
  		`<a href="${redditURL}" target="_blank"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2649_56037)">
<path d="M12.6539 25.0266C19.5648 25.0266 25.1672 19.4242 25.1672 12.5133C25.1672 5.60239 19.5648 0 12.6539 0C5.74301 0 0.140625 5.60239 0.140625 12.5133C0.140625 19.4242 5.74301 25.0266 12.6539 25.0266Z" fill="#080808"/>
<path d="M20.9989 12.5132C20.9616 11.5055 20.1154 10.7185 19.1046 10.7527C18.6566 10.7683 18.2306 10.9519 17.9072 11.2597C16.4827 10.2892 14.8092 9.75725 13.0891 9.71999L13.9008 5.8164L16.5789 6.3795C16.6534 7.06689 17.2693 7.56464 17.9567 7.48984C18.6441 7.41532 19.1419 6.79939 19.0671 6.11199C18.9923 5.4246 18.3766 4.92684 17.6892 5.00165C17.2941 5.04197 16.9395 5.27221 16.7438 5.61452L13.6769 5.00165C13.4686 4.95493 13.2601 5.08562 13.2134 5.29724C13.2134 5.3003 13.2134 5.3003 13.2134 5.30336L12.2896 9.64546C10.5478 9.67355 8.85263 10.2086 7.40943 11.1852C6.67532 10.4947 5.51826 10.5289 4.8278 11.2661C4.13735 12.0002 4.17155 13.1572 4.90872 13.8477C5.05193 13.9815 5.21655 14.0966 5.40008 14.1775C5.38756 14.361 5.38756 14.5446 5.40008 14.7281C5.40008 17.5305 8.66604 19.8104 12.6939 19.8104C16.7218 19.8104 19.9878 17.5336 19.9878 14.7281C20.0003 14.5446 20.0003 14.361 19.9878 14.1775C20.6162 13.8633 21.0114 13.2162 20.9989 12.5132ZM8.48557 13.7668C8.48557 13.0763 9.04867 12.5132 9.73913 12.5132C10.4296 12.5132 10.9927 13.0763 10.9927 13.7668C10.9927 14.4572 10.4296 15.0203 9.73913 15.0203C9.04561 15.0139 8.48557 14.4572 8.48557 13.7668ZM15.7547 17.2566V17.2068C14.8651 17.8756 13.7765 18.2176 12.6628 18.1712C11.5491 18.2179 10.4607 17.8756 9.57089 17.2068C9.45271 17.0636 9.4744 16.8492 9.61761 16.731C9.74191 16.6284 9.91932 16.6284 10.047 16.731C10.7997 17.2816 11.7173 17.5616 12.6503 17.518C13.5835 17.5678 14.5042 17.3003 15.2661 16.7561C15.4029 16.6223 15.6268 16.6254 15.7608 16.7622C15.8945 16.899 15.8915 17.1228 15.7547 17.2566ZM15.5837 15.1104C15.562 15.1104 15.5433 15.1104 15.5214 15.1104L15.5308 15.0637C14.8404 15.0637 14.2773 14.5006 14.2773 13.8102C14.2773 13.1197 14.8404 12.5566 15.5308 12.5566C16.2213 12.5566 16.7844 13.1197 16.7844 13.8102C16.8122 14.5009 16.2741 15.0823 15.5837 15.1104Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_2649_56037">
<rect width="25.3333" height="25.3333" fill="white"/>
</clipPath>
</defs>
</svg>


</a>` +
  		`<a href="${facebookURL}" target="_blank"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M25.6654 12.7435C25.6654 5.70507 19.9949 0 12.9987 0C6.00248 0 0.332031 5.70507 0.332031 12.7435C0.332031 19.1056 4.96296 24.3774 11.0193 25.3333V16.4278H7.80367V12.7427H11.0193V9.93573C11.0193 6.74204 12.91 4.97716 15.8039 4.97716C17.1888 4.97716 18.6396 5.22627 18.6396 5.22627V8.36253H17.0411C15.4679 8.36253 14.9781 9.34547 14.9781 10.3537V12.7435H18.491L17.9294 16.427H14.9781V25.3333C21.0344 24.3774 25.6654 19.1056 25.6654 12.7435Z" fill="#080808"/>
</svg>
 </a>` +
  		`<a href="${linkedInURL}" target="_blank"><svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M24.1879 2.63399V22.6984C24.1879 23.1572 24.0056 23.5971 23.6813 23.9215C23.3569 24.2459 22.9169 24.4281 22.4582 24.4281H2.39375C1.93501 24.4281 1.49506 24.2459 1.17068 23.9215C0.846297 23.5971 0.664063 23.1572 0.664062 22.6984L0.664063 2.63399C0.664063 2.17525 0.846297 1.73529 1.17068 1.41091C1.49506 1.08653 1.93501 0.904297 2.39375 0.904297L22.4582 0.904297C22.9169 0.904297 23.3569 1.08653 23.6813 1.41091C24.0056 1.73529 24.1879 2.17525 24.1879 2.63399ZM7.58283 9.8987H4.12345V20.9687H7.58283V9.8987ZM7.89418 6.09337C7.896 5.8317 7.84626 5.57223 7.74781 5.32978C7.64935 5.08732 7.5041 4.86664 7.32035 4.68032C7.13661 4.494 6.91796 4.34571 6.6769 4.24389C6.43584 4.14208 6.17708 4.08874 5.91541 4.08693H5.85314C5.321 4.08693 4.81065 4.29832 4.43437 4.6746C4.05809 5.05088 3.8467 5.56123 3.8467 6.09337C3.8467 6.62551 4.05809 7.13586 4.43437 7.51214C4.81065 7.88842 5.321 8.09982 5.85314 8.09982C6.11483 8.10625 6.37523 8.06106 6.61945 7.96683C6.86367 7.8726 7.08693 7.73117 7.27648 7.55062C7.46602 7.37007 7.61813 7.15394 7.72412 6.91459C7.83011 6.67523 7.88789 6.41734 7.89418 6.15564V6.09337ZM20.7285 14.2437C20.7285 10.9158 18.6113 9.62195 16.508 9.62195C15.8194 9.58746 15.1337 9.73414 14.5194 10.0474C13.9051 10.3606 13.3837 10.8294 13.0071 11.407H12.9103V9.8987H9.65846V20.9687H13.1178V15.0809C13.0678 14.4778 13.2578 13.8794 13.6464 13.4157C14.0351 12.9519 14.591 12.6602 15.1935 12.6039H15.3249C16.425 12.6039 17.2414 13.2958 17.2414 15.0393V20.9687H20.7008L20.7285 14.2437Z" fill="#080808"/>
</svg>
 </a>` +
  		`<a href="${twitterURL}" target="_blank"><svg width="26" height="22" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.2632 5.89434C23.2787 6.12011 23.2787 6.34588 23.2787 6.57373C23.2787 13.5164 18.0504 21.5234 8.49034 21.5234V21.5192C5.66626 21.5234 2.90085 20.7056 0.523438 19.1637C0.934081 19.2137 1.34678 19.2386 1.76052 19.2397C4.10088 19.2418 6.37434 18.4479 8.21555 16.9862C5.99149 16.9435 4.04118 15.4776 3.35987 13.3374C4.13896 13.4893 4.94172 13.4581 5.7064 13.2469C3.28165 12.7517 1.53718 10.598 1.53718 8.09689C1.53718 8.074 1.53718 8.05216 1.53718 8.03031C2.25967 8.43711 3.06861 8.66288 3.89607 8.68785C1.61231 7.14492 0.908352 4.07363 2.28746 1.67236C4.92628 4.95485 8.81968 6.95036 12.9992 7.16156C12.5803 5.33668 13.1525 3.42441 14.5028 2.14158C16.5962 0.152318 19.8885 0.254279 21.8563 2.36943C23.0203 2.13742 24.136 1.70565 25.1569 1.09389C24.7689 2.31013 23.9569 3.34326 22.8721 3.99976C23.9024 3.87699 24.9089 3.59816 25.8568 3.17263C25.159 4.22969 24.2801 5.15045 23.2632 5.89434Z" fill="#080808"/>
</svg>
</a>` +
  		`<a href="${pinterestURL}" target="_blank"><svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.8489 0C5.84608 0 0.1875 5.66899 0.1875 12.6614C0.1875 18.0282 3.5222 22.6135 8.23248 24.458C8.11785 23.4576 8.02406 21.9153 8.27415 20.8211C8.50342 19.8311 9.75392 14.5268 9.75392 14.5268C9.75392 14.5268 9.37879 13.7661 9.37879 12.651C9.37879 10.8899 10.4 9.57686 11.6714 9.57686C12.7552 9.57686 13.2762 10.3897 13.2762 11.3588C13.2762 12.4426 12.5884 14.0683 12.2237 15.5793C11.9215 16.8403 12.8594 17.8719 14.0995 17.8719C16.3504 17.8719 18.0803 15.4959 18.0803 12.0779C18.0803 9.04539 15.9023 6.92993 12.7864 6.92993C9.18078 6.92993 7.06532 9.62895 7.06532 12.4218C7.06532 13.5056 7.48216 14.6727 8.00321 15.3084C8.10743 15.4334 8.11785 15.5481 8.08659 15.6731C7.9928 16.0691 7.77395 16.934 7.73227 17.1112C7.68016 17.3405 7.54468 17.3926 7.305 17.2779C5.74186 16.5276 4.76229 14.2142 4.76229 12.3592C4.76229 8.36803 7.65931 4.69984 13.1303 4.69984C17.5176 4.69984 20.9356 7.82613 20.9356 12.0153C20.9356 16.3817 18.1845 19.8936 14.3704 19.8936C13.0886 19.8936 11.8798 19.2267 11.4734 18.4347C11.4734 18.4347 10.8377 20.8523 10.6814 21.4463C10.4 22.5509 9.62888 23.9265 9.10782 24.7706C10.2958 25.1353 11.5463 25.3333 12.8594 25.3333C19.8518 25.3333 25.5208 19.6643 25.5208 12.6719C25.5104 5.66899 19.8414 0 12.8489 0Z" fill="#080808"/>
</svg>
 </a>` +
  		'</div>'

  	return content_social
  }

  // Append the share buttons to the 'share' div(s)
  let sharePanels = document.querySelectorAll('.shares')

  if (sharePanels) {
  	sharePanels.forEach((sharePanel) => {
  		sharePanel.innerHTML = kk_share_buttons()
  	})
  }

  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-filters"] && !Shopify.designMode) return;
  try {
    
    
    let blogfilterbtn = document.querySelector('#blogfilterbtn');
    let clearblogfilterbtn = document.querySelector('#clearblogfilterbtn');
    let filterURL = '/blogs/all';
    let tagFilter = document.querySelector('#tag-select');
    let categoryFilter = document.querySelector('#category-select');
    let addedTag = false;

    blogfilterbtn.addEventListener('click', function(e){
        if(tagFilter.value || categoryFilter.value){
            filterURL += '/tagged/';
        }
        if(tagFilter.value !== ""){
            filterURL += tagFilter.value;
            addedTag = true;
        }
        if(categoryFilter.value  !== ""){
            if(addedTag){
                filterURL += "+";
            }
            
            filterURL += categoryFilter.value;
        }

        window.location.href = filterURL;
    });

    clearblogfilterbtn.addEventListener('click', function(e){
        window.location.href = filterURL;
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"] && !Shopify.designMode) return;
  try {
    
  if (enable_minmax_buys) {
    _checkCartPageQuantities(mins, maxs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-jaxxed"] && !Shopify.designMode) return;
  try {
    
// mob menu
let hamburger = document.querySelector('.hamburger');

if(hamburger){
hamburger.addEventListener('click', function(){
document.documentElement.classList.toggle('menu-open');
});
}

// sub nav trigger
let subNavTriggers = document.querySelectorAll('.sub-menu-trigger');
subNavTriggers.forEach((el) => {
el.addEventListener('click', function(e){
e.preventDefault();
el.closest('li').classList.toggle('active');
});
});

// Mega Menu

// Toggle MegaBtton Text
document.querySelectorAll('[data-mega-menu] > button').forEach(function(MegaButton) {
// Define the texts
const MegaIsClosedText = MegaButton.innerText;
const MegaIsOpenText = 'Close';

// Event listener for clicks
MegaButton.addEventListener('click', function() {
// Toggle the text content
if (this.innerText === MegaIsClosedText) {
this.innerText = MegaIsOpenText;
this.parentElement.classList.add('active');
this.classList.add('active');
} else {
this.innerText = MegaIsClosedText;
this.parentElement.classList.remove('active');
this.classList.remove('active');
}
});
});

// Trigger

if (window.matchMedia("(min-width: 992px)").matches) {
let mmLinks = document.querySelectorAll('.megamenu__links li a');
mmLinks.forEach(function(el, index){
el.addEventListener('mouseover', function(){
let thisIndex = el.dataset.index;
let relatedLists = el.closest('.megamenu').querySelectorAll('.megamenu li[data-index="'+thisIndex+'"]');
let activeLists =  el.closest('.megamenu').querySelectorAll('.megamenu li.active');

if(!relatedLists){
return;
}

activeLists.forEach((el) => {
el.classList.remove('active');
});

relatedLists.forEach((el) => {
el.classList.add('active');
});
});
});
}

// Mega Menu Tab Controller

document.addEventListener("DOMContentLoaded", function() {
var mobileTabs = document.querySelectorAll(".mobile-tab");

mobileTabs.forEach(function(tab) {
tab.addEventListener("click", function() {
var tabId = this.getAttribute("data-tab");

// Remove active class from all tabs
mobileTabs.forEach(function(tab) {
tab.classList.remove("active");
});

// Add active class to the clicked tab
this.classList.add("active");

// Hide all sub-menu-options & Images
var allSubMenus = document.querySelectorAll(".megamenu__links > ul li, ul.megamenu__end > li");
allSubMenus.forEach(function(menu) {
menu.classList.remove("active");
});

// Show the sub-menu-options for the clicked tab
var targetSubMenu = document.querySelectorAll('li[data-tab="' + tabId + '"]');
targetSubMenu.forEach(function(tmenu) {
tmenu.classList.add("active");
});

});
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
// mob menu
let hamburger = document.querySelector('.hamburger');

if(hamburger){
hamburger.addEventListener('click', function(){
document.documentElement.classList.toggle('menu-open');
});
}

// sub nav trigger
let subNavTriggers = document.querySelectorAll('.sub-menu-trigger');
subNavTriggers.forEach((el) => {
el.addEventListener('click', function(e){
e.preventDefault();
el.closest('li').classList.toggle('active');
});
});

// Mega Menu

// Toggle MegaBtton Text
document.querySelectorAll('[data-mega-menu] > button').forEach(function(MegaButton) {
// Define the texts
const MegaIsClosedText = MegaButton.innerText;
const MegaIsOpenText = 'Close';

// Event listener for clicks
MegaButton.addEventListener('click', function() {
// Toggle the text content
if (this.innerText === MegaIsClosedText) {
this.innerText = MegaIsOpenText;
this.parentElement.classList.add('active');
this.classList.add('active');
} else {
this.innerText = MegaIsClosedText;
this.parentElement.classList.remove('active');
this.classList.remove('active');
}
});
});

// Trigger

if (window.matchMedia("(min-width: 992px)").matches) {
let mmLinks = document.querySelectorAll('.megamenu__links li a');
mmLinks.forEach(function(el, index){
el.addEventListener('mouseover', function(){
let thisIndex = el.dataset.index;
let relatedLists = el.closest('.megamenu').querySelectorAll('.megamenu li[data-index="'+thisIndex+'"]');
let activeLists =  el.closest('.megamenu').querySelectorAll('.megamenu li.active');

if(!relatedLists){
return;
}

activeLists.forEach((el) => {
el.classList.remove('active');
});

relatedLists.forEach((el) => {
el.classList.add('active');
});
});
});
}

// Mega Menu Tab Controller

document.addEventListener("DOMContentLoaded", function() {
var mobileTabs = document.querySelectorAll(".mobile-tab");

mobileTabs.forEach(function(tab) {
tab.addEventListener("click", function() {
var tabId = this.getAttribute("data-tab");

// Remove active class from all tabs
mobileTabs.forEach(function(tab) {
tab.classList.remove("active");
});

// Add active class to the clicked tab
this.classList.add("active");

// Hide all sub-menu-options & Images
var allSubMenus = document.querySelectorAll(".megamenu__links > ul li, ul.megamenu__end > li");
allSubMenus.forEach(function(menu) {
menu.classList.remove("active");
});

// Show the sub-menu-options for the clicked tab
var targetSubMenu = document.querySelectorAll('li[data-tab="' + tabId + '"]');
targetSubMenu.forEach(function(tmenu) {
tmenu.classList.add("active");
});

});
});
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-compare"] && !Shopify.designMode) return;
  try {
    
    const pointerScroll = (elem) => {
        const dragStart = (ev) => elem.setPointerCapture(ev.pointerId);
        const dragEnd = (ev) => elem.releasePointerCapture(ev.pointerId);
        const drag = (ev) => elem.hasPointerCapture(ev.pointerId) && (elem.scrollLeft -= ev.movementX);

        elem.addEventListener("pointerdown", dragStart);
        elem.addEventListener("pointerup", dragEnd);
        elem.addEventListener("pointermove", drag);
    };

    document.querySelectorAll(".compare-table").forEach(pointerScroll);
    
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cross-sell"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-cross-sells");

        if (productRecommendationsSection === null) { return; }


        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300 && request.response !== "") {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                productRecommendationsSection.innerHTML = container.querySelector(".product-cross-sells").innerHTML;

                if(document.querySelector(".product-cross-sells").textContent.trim() === ""){
                    document.querySelector(".product-cross-sells").closest('section').remove();
                } else {
                    window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
                    window.globalQuickView();
                }

            }else{
                window.initSlider(document.querySelector('.cross-sell-slider'), 1, 'section');
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-cross-sell") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
    var loadProductRecommendationsIntoSection = function() {
        // Look for an element with class 'product-recommendations'
        var productRecommendationsSection = document.querySelector(".product-recommendations");

        if (productRecommendationsSection === null) { return; }

        // Build request URL
        var requestUrl = productRecommendationsSection.dataset.url;

        console.log('build: ', requestUrl);

        // Create request and submit it using Ajax
        var request = new XMLHttpRequest();

        request.open("GET", requestUrl);

        request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
                var container = document.createElement("div");
                container.innerHTML = request.response;

                console.log('build: ', request.response);

                productRecommendationsSection.innerHTML = container.querySelector(".product-recommendations").innerHTML;

                window.initSlider(document.querySelector('.related-slider'), 1, 'section');

                window.globalQuickView();
            }
        };

        request.send();
    };
    // If your section has theme settings, the theme editor
    // reloads the section as you edit those settings. When that happens, the
    // recommendations need to be fetched again.
    // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
    document.addEventListener("shopify:section:load", function(event) {
        if (event.detail.sectionId === "product-recommendations") {
            loadProductRecommendationsIntoSection();
        }
    });

    // Fetching the recommendations on page load
    loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
